module.exports = __webpack_public_path__ + "static/media/3.e567c95.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/3.wav
// module id = Thui
// module chunks = 0